import axios, { encodeData } from "../utils/axios";

export const fetchPortAuthorityPrfcs = async () => {
  const res = await axios.get("/portAuthorityPrfcs").catch((error) => {
    if (error.response) {
      console.error(error);
    }
  });

  return res.data;
};

export const fetchPrfcsForPortAuthority = async (pauth_id) => {
  const res = await axios
    .get("/portAuthorityPrfcs/by-port-auth/?pauth_id=" + pauth_id)
    .catch((error) => {
      if (error.response) {
        console.error(error);
      }
    });

  return res.data;
};

export const createPortAuthorityPrfcs = async (newportAuthorityPrfcs) => {
  await axios.post(
    "/portAuthorityPrfcs/create",
    encodeData(newportAuthorityPrfcs)
  );
};

export const updatePortAuthorityPrfcs = async (updatedportAuthorityPrfcs) => {
  await axios.put(
    "/portAuthorityPrfcs/update",
    encodeData(updatedportAuthorityPrfcs)
  );
};

export const deletePortAuthorityPrfcs = async (oldportAuthorityPrfcs) => {
  await axios.delete("/portAuthorityPrfcs/delete", {
    data: encodeData(oldportAuthorityPrfcs),
  });
};

export const deletePortAuthorityPrfcsByPrfIdAndPauthId = async (
  oldportAuthorityPrfcs
) => {
  await axios.delete("/portAuthorityPrfcs/delete-by-prf-id", {
    data: encodeData(oldportAuthorityPrfcs),
  });
};
